import React from 'react';
import CorrugatedCardboardMaterialsSection from 'components/quote_builder_widget/CorrugatedCardboardMaterialsSection';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const CorrugatedMaterialsSectionWrapper = ({
  showCorrugatedCardboardMaterials,
  setShowCorrugatedCardboardMaterials,
  onMaterialsChange,
}) => {
  return (
    <div>
      <h4 className={styles.sectionHeader}>
        {t('quote_builder_widget.section_corrugated_materials')}
      </h4>

      <div className={styles.fieldGroup}>
        <label className={styles.label}>
          {t('quote_builder_widget.corrugated_materials_enable_disable') || 'Enable / Disable'}
        </label>
        <p className={styles.helpText}>
          {t('quote_builder_widget.corrugated_cardboard_materials_info') || 'Materials available in the widget for corrugated cardboard drawings'}
        </p>

        <div className={showCorrugatedCardboardMaterials ? styles.toggleContainerEnabled : styles.toggleContainer}>
          <label className={styles.toggleLabel}>
            <input
              type="checkbox"
              checked={showCorrugatedCardboardMaterials}
              onChange={(event) => setShowCorrugatedCardboardMaterials(event.target.checked)}
              className={styles.toggleCheckbox}
            />
            <span className={styles.toggleText}>
              {showCorrugatedCardboardMaterials
                ? (t('quote_builder_widget.corrugated_materials_enabled') || 'Corrugated materials are enabled')
                : (t('quote_builder_widget.corrugated_materials_disabled') || 'Corrugated materials are disabled')}
            </span>
          </label>
        </div>
      </div>

      {showCorrugatedCardboardMaterials && (
        <div className={styles.fieldGroup}>
          <label className={styles.label}>
            {t('quote_builder_widget.corrugated_unit_prices') || 'Unit Prices'}
          </label>
          <p className={styles.helpText}>
            {t('quote_builder_widget.corrugated_unit_prices_info') || 'Select which unit prices are available in the widget for corrugated cardboard drawings.'}
          </p>

          <CorrugatedCardboardMaterialsSection onMaterialsChange={onMaterialsChange} />
        </div>
      )}
    </div>
  );
};

export default CorrugatedMaterialsSectionWrapper;
